import { render, staticRenderFns } from "./student-info-entry.vue?vue&type=template&id=81549bd8&scoped=true&"
import script from "./student-info-entry.vue?vue&type=script&lang=js&"
export * from "./student-info-entry.vue?vue&type=script&lang=js&"
import style0 from "./student-info-entry.vue?vue&type=style&index=0&id=81549bd8&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81549bd8",
  null
  
)

export default component.exports